/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, theme } from "@nordcloud/gnui";
import { ReservationTooltipRowData } from "../types";
import { ReservationTooltip } from "./ReservationsCommitmentsTooltip/ReservationTooltip";

type Props = {
  values: ReservationTooltipRowData[];
};

export function CoverageTooltip({ values }: Props) {
  const usageGraphData = values.filter((graphData) => graphData.value > 0);

  return (
    <div
      css={{
        backgroundColor: theme.color.background.ui05,
        color: theme.color.text.text04,
        padding: `${theme.spacing.spacing01} ${theme.spacing.spacing02}`,
        borderRadius: theme.radiusDefault,
      }}
    >
      <Text size="sm" mb="0" color={theme.color.text.text04}>
        Coverage Details
      </Text>
      <ReservationTooltip values={usageGraphData} suffix="%" />
    </div>
  );
}
